<template>
  <el-tabs v-model="activeName">
    <!--5.10顾客分析-->
    <el-tab-pane label="顾客分析" name="second">
      <div v-if="Lib.checkPower('beauty-3-gkfxbb',2)">
        <date-picker @selectDate="initGetSignSuccess" />
        <div class="analyseBar">
          <div class="analyseBar-top">
            <h2>
              顾客流量趋势
            </h2>
            <el-checkbox v-model="repeatType" @change="onlyDataCheckbox">
              去除重复消费的顾客
            </el-checkbox>
          </div>
          <div id="barDate" style="width:1700px;height:300px;margin:0 auto"></div>
        <!-- <div id="barDate" style="min-width:1700px;height:300px"></div> -->
        </div>
        <ul class="analysePie">
          <li>
            <div id="pieExpense" style="width:800px;height:300px;"></div>
          </li>
          <li>
            <div id="pieExpenseTow" style="width:800px;height:300px;"></div>
          </li>
        </ul>
        <ul class="analysePie">
          <li>
            <div id="pieExpenseThree" style="width:800px;height:300px;"></div>
          </li>
          <li>
            <div id="pieExpenseFour" style="width:800px;height:300px;"></div>
          </li>
        </ul>
      </div>
      <gt-noneData v-else :title="'暂无权限，请联系管理员分配权限'" :is-no-permission="true"></gt-noneData>
    </el-tab-pane>
    <el-tab-pane label="顾客明细" name="first">
      <div v-if="Lib.checkPower('beauty-4-ckgkmxbb',2)">
        <el-row>
          <date-picker @selectDate="onChangeTime" />
        <!-- <el-date-picker v-model="time" type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd" :picker-options="expireTimeOption" :clearable="false" @change="onChangeTime">></el-date-picker> -->
        </el-row>
        <el-row :gutter="20">
          <el-col :span="4">
            <div class="data_total">
              <span class="data_num">{{ headerData.peopleTotle }}</span>
              <span class="data_content">总客流量</span>
            </div>
          </el-col>
          <el-col :span="20">
            <el-row :gutter="20">
              <el-col :span="12">
                <div class="data_dispersed">
                  <div class="data_Tbox">
                    <span class="data_xnum">{{ headerData.memberConsumeTotle }}</span>
                    <span class="data_content">会员消费人次</span>
                  </div>
                  <div class="data_Tbox">
                    <span class="data_xnum">{{ headerData.notMemberConsumeTotle }}</span>
                    <span class="data_content">散客消费人次</span>
                  </div>
                </div>
              </el-col>
              <el-col :span="12">
                <div class="data_dispersed">
                  <div class="data_Tbox">
                    <span class="data_xnum">{{ headerData.guestTotle }}</span>
                    <span class="data_content">指定客消费次数</span>
                  </div>
                  <div class="data_Tbox">
                    <span class="data_xnum">{{ headerData.notGuestTotle }}</span>
                    <span class="data_content">非指定客消费次数</span>
                  </div>
                </div>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="20">
                <div class="data_dispersed">
                  <div class="data_Sbox">
                    <span class="data_xnum">{{ headerData.manSellTotle }}</span>
                    <span class="data_content">男客消费人数<el-tooltip placement="right" width="200" trigger="hover" effect="light">
                      <div slot="content">
                        <p class="tooltip-p">统计同一订单的全部男客的消费人数</p>
                      </div>
                      <i class="iconfont iconCdThree">&#xe71a;</i>
                    </el-tooltip></span>
                  </div>
                  <div class="data_Sbox">
                    <span class="data_xnum">{{ headerData.womanSellTotle }}</span>
                    <span class="data_content">女客消费人数<el-tooltip placement="right" width="200" trigger="hover" effect="light">
                      <div slot="content">
                        <p class="tooltip-p">统计同一订单的全部女客的消费人数</p>
                      </div>
                      <i class="iconfont iconCdThree">&#xe71a;</i>
                    </el-tooltip></span>
                  </div>
                  <div class="data_Sbox">
                    <span class="data_xnum">{{ headerData.midSellTotle }}</span>
                    <span class="data_content">未知性别消费人数<el-tooltip placement="right" width="200" trigger="hover" effect="light">
                      <div slot="content">
                        <p class="tooltip-p">统计同一订单的全部未知性别客的消费人数</p>
                      </div>
                      <i class="iconfont iconCdThree">&#xe71a;</i>
                    </el-tooltip></span>
                  </div>
                </div>
              </el-col>
              <el-col :span="4">
                <div class="data_dispersed">
                  <div class="data_Obox">
                    <span class="data_xnum">{{ headerData.customerTotle }}</span>
                    <span class="data_content">新增顾客人数</span>
                  </div>
                </div>
              </el-col>
            </el-row>
          </el-col>
        </el-row>
        <br />
        <div style="position:relative;">
          <el-tabs v-model="activeName2" type="card">
            <el-tab-pane label="客流明细" name="first">
              <el-table v-loading="loading1" tooltip-effect="light" :data="pageData" style="width: 100%" height="450">
                <el-table-column align="left" prop="dataTime" label="日期"></el-table-column>
                <el-table-column align="left" prop="memberConsumeNum" label="会员消费人次"></el-table-column>
                <el-table-column align="left" prop="notMemberConsumeNum" label="散客消费人次"></el-table-column>
                <el-table-column align="left" prop="guestNum" label="指定客消费次数"></el-table-column>
                <el-table-column align="left" prop="notGuestNum" label="非指定客消费次数"></el-table-column>
                <el-table-column align="left" prop="manSellNum" label="男客消费人数">
                  <template slot="header" slot-scope="scope">
                    <span v-show="scope">男客消费人数</span>
                    <el-tooltip effect="light" placement="top">
                      <div slot="content">
                        <p class="tooltip-p">统计同一订单的全部男客的消费人数</p>
                      </div>
                      <i class="iconfont iconCdThree">&#xe71a;</i>
                    </el-tooltip>
                  </template>
                </el-table-column>
                <el-table-column align="left" prop="womanSellNum" label="女客消费人数">
                  <template slot="header" slot-scope="scope">
                    <span v-show="scope">女客消费人数</span>
                    <el-tooltip effect="light" placement="top">
                      <div slot="content">
                        <p class="tooltip-p">统计同一订单的全部女客的消费人数</p>
                      </div>
                      <i class="iconfont iconCdThree">&#xe71a;</i>
                    </el-tooltip>
                  </template>
                </el-table-column>
                <el-table-column align="left" prop="midSellNum" label="未知性别客消费人数">
                  <template slot="header" slot-scope="scope">
                    <span v-show="scope">未知性别客消费人数</span>
                    <el-tooltip effect="light" placement="top">
                      <div slot="content">
                        <p class="tooltip-p">统计同一订单的全部未知性别客的消费人数</p>
                      </div>
                      <i class="iconfont iconCdThree">&#xe71a;</i>
                    </el-tooltip>
                  </template>
                </el-table-column>
                <el-table-column align="left" prop="peopleNum" label="客流量"></el-table-column>
              </el-table>
              <el-pagination background layout="prev, pager, next" :current-page.sync="currentPage" :total="pageTotal" @current-change="pageDataFn"></el-pagination>
            </el-tab-pane>
            <el-tab-pane label="新增顾客明细" name="second">
              <el-table v-loading="loading2" tooltip-effect="light" :data="pageDataT" style="width: 100%" height="450">
                <el-table-column align="left" prop="dataTime" label="日期"></el-table-column>
                <el-table-column align="left" prop="memberCount" label="新增会员人数"></el-table-column>
                <el-table-column align="left" prop="guestCount" label="新增散客人数"></el-table-column>
                <el-table-column align="left" prop="customerCount" label="新增顾客人数"></el-table-column>
              </el-table>
              <el-pagination background layout="prev, pager, next" :current-page.sync="currentPage" :total="pageTotalT" @current-change="pageDataFn"></el-pagination>
            </el-tab-pane>
          </el-tabs>
          <div class="button_group">
            <el-button type="primary" size="small" @click="onDownload">导出报表</el-button>
            <el-button type="primary" size="small" @click="onPrint">打印报表</el-button>
          </div>
        </div>
      </div>
      <gt-noneData v-else :title="'暂无权限，请联系管理员分配权限'" :is-no-permission="true"></gt-noneData>
    </el-tab-pane>
  </el-tabs>
</template>

<script>
import dayjs from 'dayjs';
// import echarts from 'echarts';
import * as echarts from 'echarts';
import api from './api/index';
import { echartsA } from './echarts/echartsA';
import { echartsB } from './echarts/echartsB';
import { echartsC } from './echarts/echartsC';
import { echartsD } from './echarts/echartsD';
import { echartsE } from './echarts/echartsE';

export default {
  data() {
    return {
      activeName: 'second',
      activeName2: 'first',
      time: [
        dayjs()
          .subtract(30, 'day')
          .format('YYYY-MM-DD'),
        dayjs().format('YYYY-MM-DD')
      ],
      tableData: [], // 客流明细
      tableDataT: [], //  新增顾客明细
      headerData: {},
      pageTotal: 0,
      pageTotalT: 0,
      pageData: [],
      pageDataT: [],
      expireTimeOption: {
        disabledDate(date) {
          return date.getTime() > Date.now();
        }
      },
      currentPage: 1,
      // 5.7
      loading1: true,
      loading2: true,
      repeatType: true, // 是否去除重复消费的顾客（0：否false，1：是true）
      myChartA: '',
      myChartB: '',
      myChartC: '',
      myChartD: '',
      myChartE: '',
    };
  },
  watch: {
    activeName2(val) {
      this.currentPage = 1;
      this.onGetAnalyse(JSON.parse(window.sessionStorage.getItem('selectDate')));
      if (val === 'second') {
        this.onGetAndMember(JSON.parse(window.sessionStorage.getItem('selectDate')));
      }
    },
    activeName(val) {
      this.currentPage = 1;
      if (val === 'first') {
        this.onGetAnalyse(JSON.parse(window.sessionStorage.getItem('selectDate')));
      }
    },
  },
  activated() {
    this.currentPage = 1;
    this.initGetSignSuccess(JSON.parse(window.sessionStorage.getItem('selectDate')));
  },
  methods: {
    onChangeTime(e) {
      this.onGetAnalyse(e);
      if (this.activeName2 === 'second') {
        this.onGetAndMember(e);
      }
    },
    // 获取客流明细
    onGetAnalyse(e) {
      this.loading1 = true;
      const data = {
        // beginTime: this.time[0],
        // endTime: this.time[1],
        beginTime: e ? e.beginTime : dayjs().subtract(8, 'day').format('YYYY-MM-DD'),
        endTime: e ? e.endTime : dayjs().format('YYYY-MM-DD'),
        dateType: e ? e.dateType : 'DAY',
        mainId: sessionStorage.getItem('mainId')
      };
      api.getAnalyse(data).then((res) => {
        this.headerData = res.data;
        const arr = [];
        this.pageTotal = Object.keys(res.data.page).length;
        for (const key in res.data.page) {
          res.data.page[key].customerNum ? '' : (res.data.page[key].customerNum = 0);
          res.data.page[key].dataTime ? '' : (res.data.page[key].dataTime = key);
          res.data.page[key].guestNum ? '' : (res.data.page[key].guestNum = 0);
          res.data.page[key].manSellNum ? '' : (res.data.page[key].manSellNum = 0);
          res.data.page[key].memberConsumeNum ? '' : (res.data.page[key].memberConsumeNum = 0);
          res.data.page[key].memberNum ? '' : (res.data.page[key].memberNum = 0);
          res.data.page[key].midSellNum ? '' : (res.data.page[key].midSellNum = 0);
          res.data.page[key].notGuestNum ? '' : (res.data.page[key].notGuestNum = 0);
          res.data.page[key].notMemberConsumeNum ? '' : (res.data.page[key].notMemberConsumeNum = 0);
          res.data.page[key].peopleNum ? '' : (res.data.page[key].peopleNum = 0);
          res.data.page[key].vipCardConsumeNum ? '' : (res.data.page[key].vipCardConsumeNum = 0);
          res.data.page[key].vipCardDeducNum ? '' : (res.data.page[key].vipCardDeducNum = 0);
          res.data.page[key].womanSellNum ? '' : (res.data.page[key].womanSellNum = 0);
          // res.data.page[key].unix = dayjs(key).unix();
          arr.push(res.data.page[key]);
        }
        // arr.sort((a, b) => a.unix - b.unix);
        this.tableData = arr;
        this.loading1 = false;
        this.pageDataFn(1);
      });
    },
    // 获取顾客明细
    onGetAndMember(e) {
      this.loading2 = true;
      const data = {
        // beginTime: this.time[0],
        // endTime: this.time[1],
        beginTime: e ? e.beginTime : dayjs().subtract(8, 'day').format('YYYY-MM-DD'),
        endTime: e ? e.endTime : dayjs().format('YYYY-MM-DD'),
        dateType: e ? e.dateType : 'DAY',
        mainId: sessionStorage.getItem('mainId')
      };
      api.getCustomerAndMember(data).then((res) => {
        const arr = [];
        this.pageTotalT = Object.keys(res.data).length;
        for (const key in res.data) {
          res.data[key].customerCount ? '' : (res.data[key].customerCount = 0);
          res.data[key].dataTime ? '' : (res.data[key].dataTime = key);
          res.data[key].guestCount ? '' : (res.data[key].guestCount = 0);
          res.data[key].memberCount ? '' : (res.data[key].memberCount = 0);
          // res.data[key].unix = dayjs(key).unix();
          arr.push(res.data[key]);
        }
        // arr.sort((a, b) => a.unix - b.unix);
        this.tableDataT = arr;
        this.loading2 = false;
        this.pageDataFn(1);
      });
    },
    // 分页数据处理函数
    pageDataFn(number) {
      // 处于第几页 number
      // 保存每页数据的函数
      const pagedata = [];
      // pagesize=10 每页条数
      // 设置开始
      const start = 10 * number - 10;
      // 设置结束长度
      let end = 10 * number; // 长度判断 //所有分页数据 this.tableData
      if (this.activeName2 == 'first') {
        end = end > this.tableData.length ? this.tableData.length : end;
        for (let i = start; i < end; i++) {
          // 所有分页数据 this.tableData
          pagedata.push(this.tableData[i]);
        }
        this.pageData = pagedata;
      } else {
        end = end > this.tableDataT.length ? this.tableDataT.length : end;
        for (let i = start; i < end; i++) {
          // 所有分页数据 this.tableData
          pagedata.push(this.tableDataT[i]);
        }
        this.pageDataT = pagedata;
      }
    },
    onDownload() {
      if (this.Lib.checkPower('beauty-4-dcgkmxbb') == false) return;
      const item = JSON.parse(window.sessionStorage.getItem('selectDate'));
      if (this.activeName2 == 'first') {
        this.$root.$children[0].fatherExport('exportMemberCount', item.beginTime, item.endTime, item.dateType);
      } else {
        this.$root.$children[0].fatherExport('exportCustomerAndMember', item.beginTime, item.endTime, item.dateType);
      }
    },
    onPrint() {
      if (this.Lib.checkPower('beauty-4-dygkmxbb') == false) return;
      if (this.activeName2 == 'first') {
        this.$print({
          data: this.tableData,
          table_tol: [
            {
              prop: 'dataTime',
              name: '日期'
            },
            {
              prop: 'memberConsumeNum',
              name: '会员消费人次'
            },
            {
              prop: 'notMemberConsumeNum',
              name: '散客消费人次'
            },
            {
              prop: 'guestNum',
              name: '指定客消费次数'
            },
            {
              prop: 'notGuestNum',
              name: '非指定客消费次数'
            },
            {
              prop: 'manSellNum',
              name: '男客消费人数'
            },
            {
              prop: 'womanSellNum',
              name: '女客消费人数'
            },
            {
              prop: 'midSellNum',
              name: '未知性别客消费人数'
            },
            {
              prop: 'peopleNum',
              name: '客流量'
            },
          ],
          title: '客流明细'
        });
      } else {
        this.$print({
          data: this.tableDataT,
          table_tol: [
            {
              prop: 'dataTime',
              name: '日期'
            },
            {
              prop: 'memberCount',
              name: '新增会员人数'
            },
            {
              prop: 'guestCount',
              name: '新增散客人数'
            },
            {
              prop: 'customerCount',
              name: '新增顾客人数'
            },
          ],
          title: '新增顾客明细'
        });
      }
    },
    // 5.10新增
    // 获取数据
    initGetSignSuccess(e) {
      // 基于准备好的dom，初始化echarts实例
      this.myChartA = echarts.init(document.getElementById('barDate'));
      this.myChartB = echarts.init(document.getElementById('pieExpense'));
      this.myChartC = echarts.init(document.getElementById('pieExpenseTow'));
      this.myChartD = echarts.init(document.getElementById('pieExpenseThree'));
      this.myChartE = echarts.init(document.getElementById('pieExpenseFour'));
      // 加载中
      const style = {
        text: '', // 加载时候的文本
      };
      this.myChartA.showLoading(style);
      this.myChartB.showLoading(style);
      this.myChartC.showLoading(style);
      this.myChartD.showLoading(style);
      this.myChartE.showLoading(style);
      // 获取数据
      const data = {
        beginTime: e ? e.beginTime : dayjs().subtract(8, 'day').format('YYYY-MM-DD'),
        endTime: e ? e.endTime : dayjs().format('YYYY-MM-DD'),
        dateType: e ? e.dateType : 'DAY',
        mainId: sessionStorage.getItem('mainId'),
        repeatType: this.repeatType == true ? 1 : 0,
      };
      api.getCustomerAnalyseMsg(data).then((res) => {
        if (res.code === 0) {
          this.drawAnalyseBar(res.data.customerCountTrendList);
          this.drawAnalysePie(res.data.customerExpenseCountList);
          this.drawAnalysePieTow(res.data.customerExpenseCountList); // 顾客消费额度统计
          this.drawAnalysePieSw(res.data.customerSourceCountList); // 顾客来源统计
          this.drawAnalysePieThird(res.data.newCustomerCountList); // 新增顾客统计;
          // 关闭加载
          this.myChartA.hideLoading();
          this.myChartB.hideLoading();
          this.myChartC.hideLoading();
          this.myChartD.hideLoading();
          this.myChartE.hideLoading();
        }
      });
    },
    // 切换
    onlyDataCheckbox() {
      this.initGetSignSuccess(JSON.parse(window.sessionStorage.getItem('selectDate')));
    },
    // 顾客流量趋势柱状图
    drawAnalyseBar(data) {
      // 基于准备好的dom，初始化echarts实例
      // const myChart = echarts.init(document.getElementById('barDate'));
      // 监听屏幕变化自动缩放图表
      window.addEventListener('resize', () => { this.myChartA.resize(); });
      // 使用刚指定的配置项和数据显示图表。
      const option = echartsA(data);
      this.myChartA.setOption(option);
    },
    // 顾客消费类型统计
    drawAnalysePie(data) {
      // 基于准备好的dom，初始化echarts实例
      // const myChart = echarts.init(document.getElementById('pieExpense'));
      // 监听屏幕变化自动缩放图表
      window.addEventListener('resize', () => { this.myChartB.resize(); });
      // 使用刚指定的配置项和数据显示图表。
      const option = echartsB(data);
      this.myChartB.setOption(option);
    },
    // 顾客消费额度统计
    drawAnalysePieTow(data) {
      // const myChart = echarts.init(document.getElementById('pieExpenseTow'));
      window.addEventListener('resize', () => { this.myChartC.resize(); });
      const option = echartsC(data);
      this.myChartC.setOption(option);
    },
    // 顾客消费统计
    drawAnalysePieSw(data) {
      // const myChart = echarts.init(document.getElementById('pieExpenseThree'));
      window.addEventListener('resize', () => { this.myChartD.resize(); });
      const option = echartsE(data);
      this.myChartD.setOption(option);
    },
    drawAnalysePieThird(data) {
      // const myChart = echarts.init(document.getElementById('pieExpenseFour'));
      window.addEventListener('resize', () => { this.myChartE.resize(); });
      const option = echartsD(data);
      this.myChartE.setOption(option);
    }
  }
};
</script>
<style scoped>
.button_group {
  position: absolute;
  right: 0;
  top: 0;
}
.data_total {
  border: 1px solid #e6ebf5;
  padding: 73px 50px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  text-align: center;
  margin-top: 20px;
}
.data_dispersed {
  border: 1px solid #e6ebf5;
  margin-top: 20px;
  text-align: center;
}
.data_Tbox {
  padding: 20px 52px;
  display: inline-grid;
}
.data_Sbox {
  padding: 20px 79px;
  display: inline-grid;
}
.data_Obox {
  padding: 20px;
  display: inline-grid;
}
.data_num {
  font-size: 36px;
  color: #fd5c8c;
  font-weight: 700;
}
.data_xnum {
  font-size: 26px;
  color: #fd5c8c;
  font-weight: 700;
}
.data_content {
  font-size: 16px;
  color: #333333;
}

</style>
<style lang="less" scoped>
/* 5.10*/
.analyseBar{
  height:327px;
  padding: 30px;
  border: solid 1px #ebeef5;
  // margin: 20px 0;
  margin-top:20px;
  overflow: auto;
  .analyseBar-top{
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
     h2{
       font-size:14px;
       color: #2d2f33;
       font-weight: 900;
  }
  }
}
.analysePie{
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    overflow: auto;
  li{
    min-width: 800px;
    height: 336px;
    // width:clac(100%/2 - 30px);
    // width: 840px;
    // height: 390px;
    background-color: #ffffff;
    border: solid 1px #ebeef5;
    display: inline-block;
    padding: 30px;
    margin-top:20px;
    // h2{
    // }
  }
  li:nth-child(odd){
    margin-right: 20px;
  }
}
.analysePie:nth-child(odd){
  margin-bottom: 20px;
}
.analysePie-text{
      font-size: 14px;
    color: #2d2f33;
    margin: 15px 0;
}
</style>
